
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./adapters/application.js"
import * as amdModule1 from "./adapters/assessments/assessment.js"
import * as amdModule2 from "./adapters/assessments/base.js"
import * as amdModule3 from "./adapters/assessments/grade-schedule.js"
import * as amdModule4 from "./adapters/assessments/grade.js"
import * as amdModule5 from "./adapters/assessments/module.js"
import * as amdModule6 from "./adapters/goals/badge.js"
import * as amdModule7 from "./adapters/goals/base.js"
import * as amdModule8 from "./adapters/goals/category.js"
import * as amdModule9 from "./adapters/goals/goal.js"
import * as amdModule10 from "./adapters/goals/state.js"
import * as amdModule11 from "./adapters/goals/subcategory.js"
import * as amdModule12 from "./adapters/goals/subject.js"
import * as amdModule13 from "./adapters/media.js"
import * as amdModule14 from "./adapters/notifications/base.js"
import * as amdModule15 from "./adapters/notifications/notification.js"
import * as amdModule16 from "./adapters/notifications/result.js"
import * as amdModule17 from "./adapters/people-schema/base.js"
import * as amdModule18 from "./adapters/people-schema/field.js"
import * as amdModule19 from "./adapters/posts/base.js"
import * as amdModule20 from "./adapters/posts/comment.js"
import * as amdModule21 from "./adapters/posts/feed-entry.js"
import * as amdModule22 from "./adapters/posts/page.js"
import * as amdModule23 from "./adapters/posts/post.js"
import * as amdModule24 from "./adapters/posts/reaction.js"
import * as amdModule25 from "./adapters/posts/studentnotice.js"
import * as amdModule26 from "./adapters/posts/tag-category.js"
import * as amdModule27 from "./adapters/posts/tag.js"
import * as amdModule28 from "./adapters/school-options/base.js"
import * as amdModule29 from "./adapters/school-options/field.js"
import * as amdModule30 from "./adapters/school-options/group.js"
import * as amdModule31 from "./adapters/school-options/heading.js"
import * as amdModule32 from "./adapters/surveys/base.js"
import * as amdModule33 from "./adapters/surveys/response.js"
import * as amdModule34 from "./adapters/surveys/survey.js"
import * as amdModule35 from "./adapters/term.js"
import * as amdModule36 from "./adapters/timeframe.js"
import * as amdModule37 from "./config/environment.js"
import * as amdModule38 from "./deprecation-workflow.js"
import * as amdModule39 from "./enums/grading-method.ts"
import * as amdModule40 from "./models/media.ts"
import * as amdModule41 from "./models/person.ts"
import * as amdModule42 from "./models/posts/comment.ts"
import * as amdModule43 from "./models/posts/page.ts"
import * as amdModule44 from "./models/posts/post.ts"
import * as amdModule45 from "./models/posts/reaction.ts"
import * as amdModule46 from "./models/posts/studentnotice.ts"
import * as amdModule47 from "./router.js"
import * as amdModule48 from "./serializers/application.js"
import * as amdModule49 from "./serializers/assessments/assessment.js"
import * as amdModule50 from "./serializers/assessments/base.js"
import * as amdModule51 from "./serializers/assessments/category.js"
import * as amdModule52 from "./serializers/assessments/grade-schedule.js"
import * as amdModule53 from "./serializers/assessments/grade.js"
import * as amdModule54 from "./serializers/assessments/module.js"
import * as amdModule55 from "./serializers/people-schema/base.js"
import * as amdModule56 from "./serializers/people-schema/field.js"
import * as amdModule57 from "./serializers/posts/comment.js"
import * as amdModule58 from "./serializers/posts/page.js"
import * as amdModule59 from "./serializers/posts/post.js"
import * as amdModule60 from "./serializers/posts/studentnotice.js"
import * as amdModule61 from "./serializers/term.js"
import * as amdModule62 from "./services/application-data.js"
import * as amdModule63 from "./services/store.js"
import * as amdModule64 from "./services/strings.js"
import * as amdModule65 from "./services/terms.js"
import * as amdModule66 from "./initializers/viewport-config.js"
import * as amdModule67 from "./services/in-viewport.js"
import * as amdModule68 from "./services/-ensure-registered.js"
import * as amdModule69 from "./instance-initializers/ember-href-to.js"
import * as amdModule70 from "./services/constants.js"
import * as amdModule71 from "./services/paper-sidenav.js"
import * as amdModule72 from "./services/paper-theme.js"
import * as amdModule73 from "./services/paper-toaster.js"
import * as amdModule74 from "./services/sniffer.js"
import * as amdModule75 from "./utils/clamp.js"
import * as amdModule76 from "./transforms/array.js"
import * as amdModule77 from "./transforms/fragment-array.js"
import * as amdModule78 from "./transforms/fragment.js"
import * as amdModule79 from "./initializers/ember-data.js"
import * as amdModule80 from "./transforms/date.js"
import * as amdModule81 from "./transforms/number.js"
import * as amdModule82 from "./transforms/string.js"
import * as amdModule83 from "./transforms/boolean.js"
import * as amdModule84 from "./instance-initializers/ember-router-scroll.js"
import * as amdModule85 from "./services/router-scroll.js"
import * as amdModule86 from "./data-adapter.js"
import * as amdModule87 from "./adapters/base.js"
import * as amdModule88 from "./adapters/device.js"
import * as amdModule89 from "./adapters/group.js"
import * as amdModule90 from "./adapters/person.js"
import * as amdModule91 from "./adapters/policy.js"
import * as amdModule92 from "./adapters/school.js"
import * as amdModule93 from "./adapters/user.js"
import * as amdModule94 from "./initializers/fragment-array-iterable.js"
import * as amdModule95 from "./initializers/fragment-array-mutable.js"
import * as amdModule96 from "./initializers/oauth2.js"
import * as amdModule97 from "./initializers/query-params-helper.js"
import * as amdModule98 from "./instance-initializers/faro.js"
import * as amdModule99 from "./models/address.js"
import * as amdModule100 from "./models/assessments/assessment.js"
import * as amdModule101 from "./models/assessments/category.js"
import * as amdModule102 from "./models/assessments/grade-schedule.js"
import * as amdModule103 from "./models/assessments/grade.js"
import * as amdModule104 from "./models/assessments/gradeschedule-numeric.js"
import * as amdModule105 from "./models/assessments/gradeschedule-range.js"
import * as amdModule106 from "./models/assessments/gradeschedule-select.js"
import * as amdModule107 from "./models/assessments/gradeschedule-selectvalue.js"
import * as amdModule108 from "./models/assessments/module.js"
import * as amdModule109 from "./models/attendance/nz-moe-day.js"
import * as amdModule110 from "./models/auth/qr-code.js"
import * as amdModule111 from "./models/autogroup-params.js"
import * as amdModule112 from "./models/bookings/allocation.js"
import * as amdModule113 from "./models/bookings/booking.js"
import * as amdModule114 from "./models/bookings/date.js"
import * as amdModule115 from "./models/bookings/event.js"
import * as amdModule116 from "./models/bookings/reservation.js"
import * as amdModule117 from "./models/bookings/session.js"
import * as amdModule118 from "./models/bookings/slot.js"
import * as amdModule119 from "./models/bookings/teacher-group-mapping.js"
import * as amdModule120 from "./models/cron/process-monitor-error.js"
import * as amdModule121 from "./models/cron/process-monitor.js"
import * as amdModule122 from "./models/cron/progress.js"
import * as amdModule123 from "./models/device.js"
import * as amdModule124 from "./models/dynamic-field/value-list-item.js"
import * as amdModule125 from "./models/dynamic-field/value.js"
import * as amdModule126 from "./models/dynamic-field/values.js"
import * as amdModule127 from "./models/enrolments/field.js"
import * as amdModule128 from "./models/enrolments/medical-condition.js"
import * as amdModule129 from "./models/enrolments/schema.js"
import * as amdModule130 from "./models/enrolments/section.js"
import * as amdModule131 from "./models/events/cost-mapping-option.js"
import * as amdModule132 from "./models/events/cost-mapping.js"
import * as amdModule133 from "./models/events/event-count.js"
import * as amdModule134 from "./models/events/event.js"
import * as amdModule135 from "./models/events/mitigation.js"
import * as amdModule136 from "./models/events/option-count.js"
import * as amdModule137 from "./models/events/option-limit.js"
import * as amdModule138 from "./models/events/permission-reply.js"
import * as amdModule139 from "./models/events/permission.js"
import * as amdModule140 from "./models/events/risk.js"
import * as amdModule141 from "./models/events/template.js"
import * as amdModule142 from "./models/events/value-limit.js"
import * as amdModule143 from "./models/finance/account.js"
import * as amdModule144 from "./models/finance/line-item.js"
import * as amdModule145 from "./models/goals/badge-assertion.js"
import * as amdModule146 from "./models/goals/badge-badge.js"
import * as amdModule147 from "./models/goals/badge-criteria.js"
import * as amdModule148 from "./models/goals/badge-profile.js"
import * as amdModule149 from "./models/goals/badge-recipient.js"
import * as amdModule150 from "./models/goals/badge-verification.js"
import * as amdModule151 from "./models/goals/badge.js"
import * as amdModule152 from "./models/goals/category.js"
import * as amdModule153 from "./models/goals/goal.js"
import * as amdModule154 from "./models/goals/state.js"
import * as amdModule155 from "./models/goals/subcategory.js"
import * as amdModule156 from "./models/goals/subject.js"
import * as amdModule157 from "./models/group.js"
import * as amdModule158 from "./models/groups/member.js"
import * as amdModule159 from "./models/media/image.js"
import * as amdModule160 from "./models/media/rendition.js"
import * as amdModule161 from "./models/media/video.js"
import * as amdModule162 from "./models/milestones/expectation.js"
import * as amdModule163 from "./models/milestones/level.js"
import * as amdModule164 from "./models/milestones/milestone-set.js"
import * as amdModule165 from "./models/milestones/milestone.js"
import * as amdModule166 from "./models/milestones/progression.js"
import * as amdModule167 from "./models/notifications/notification.js"
import * as amdModule168 from "./models/people-schema/field-option.js"
import * as amdModule169 from "./models/people-schema/field.js"
import * as amdModule170 from "./models/people-schema/group.js"
import * as amdModule171 from "./models/people/caregiver.js"
import * as amdModule172 from "./models/people/learner.js"
import * as amdModule173 from "./models/people/medical.js"
import * as amdModule174 from "./models/people/options.js"
import * as amdModule175 from "./models/people/policy-acceptance.js"
import * as amdModule176 from "./models/people/post-count-assessment.js"
import * as amdModule177 from "./models/people/post-count-base.js"
import * as amdModule178 from "./models/people/post-count-goal.js"
import * as amdModule179 from "./models/people/post-count-page.js"
import * as amdModule180 from "./models/people/post-counts.js"
import * as amdModule181 from "./models/people/staff.js"
import * as amdModule182 from "./models/policy.js"
import * as amdModule183 from "./models/posts/attendancenote.js"
import * as amdModule184 from "./models/posts/feed-entry.js"
import * as amdModule185 from "./models/posts/globalnotice.js"
import * as amdModule186 from "./models/posts/member.js"
import * as amdModule187 from "./models/posts/page-set.js"
import * as amdModule188 from "./models/posts/post-template.js"
import * as amdModule189 from "./models/posts/tag-category.js"
import * as amdModule190 from "./models/posts/tag.js"
import * as amdModule191 from "./models/reports/report-feedback.js"
import * as amdModule192 from "./models/reports/report-judgement-wording.js"
import * as amdModule193 from "./models/reports/report-template-period.js"
import * as amdModule194 from "./models/reports/report-template-section.js"
import * as amdModule195 from "./models/reports/report-template.js"
import * as amdModule196 from "./models/reports/rubric-column.js"
import * as amdModule197 from "./models/reports/rubric-criteria.js"
import * as amdModule198 from "./models/reports/rubric-element.js"
import * as amdModule199 from "./models/reports/rubric-family.js"
import * as amdModule200 from "./models/reports/rubric-state.js"
import * as amdModule201 from "./models/reports/rubric.js"
import * as amdModule202 from "./models/reports/student-report-section-element.js"
import * as amdModule203 from "./models/reports/student-report-section.js"
import * as amdModule204 from "./models/reports/student-report.js"
import * as amdModule205 from "./models/school-options/field.js"
import * as amdModule206 from "./models/school-options/group.js"
import * as amdModule207 from "./models/school-options/heading.js"
import * as amdModule208 from "./models/school.js"
import * as amdModule209 from "./models/schools/location.js"
import * as amdModule210 from "./models/sif/au/connection.js"
import * as amdModule211 from "./models/sif/au/zone.js"
import * as amdModule212 from "./models/snapshots/pdf-include.js"
import * as amdModule213 from "./models/snapshots/pdf.js"
import * as amdModule214 from "./models/snapshots/snapshot-set.js"
import * as amdModule215 from "./models/snapshots/snapshot.js"
import * as amdModule216 from "./models/surveys/response.js"
import * as amdModule217 from "./models/surveys/survey.js"
import * as amdModule218 from "./models/term.js"
import * as amdModule219 from "./models/timeframe.js"
import * as amdModule220 from "./models/timetable/day.js"
import * as amdModule221 from "./models/timetable/period.js"
import * as amdModule222 from "./models/timetable/structure.js"
import * as amdModule223 from "./models/user.js"
import * as amdModule224 from "./models/wonde/address.js"
import * as amdModule225 from "./models/wonde/connection.js"
import * as amdModule226 from "./models/wonde/school.js"
import * as amdModule227 from "./serializers/address.js"
import * as amdModule228 from "./serializers/auth/base.js"
import * as amdModule229 from "./serializers/auth/qr-code.js"
import * as amdModule230 from "./serializers/bookings/allocation.js"
import * as amdModule231 from "./serializers/bookings/base.js"
import * as amdModule232 from "./serializers/bookings/booking.js"
import * as amdModule233 from "./serializers/bookings/event.js"
import * as amdModule234 from "./serializers/bookings/slot.js"
import * as amdModule235 from "./serializers/cron/process-monitor.js"
import * as amdModule236 from "./serializers/dynamic-field/value.js"
import * as amdModule237 from "./serializers/events/base.js"
import * as amdModule238 from "./serializers/events/cost-mapping-option.js"
import * as amdModule239 from "./serializers/events/cost-mapping.js"
import * as amdModule240 from "./serializers/events/event-count.js"
import * as amdModule241 from "./serializers/events/event.js"
import * as amdModule242 from "./serializers/events/mitigation.js"
import * as amdModule243 from "./serializers/events/permission-reply.js"
import * as amdModule244 from "./serializers/events/permission.js"
import * as amdModule245 from "./serializers/events/risk.js"
import * as amdModule246 from "./serializers/events/template.js"
import * as amdModule247 from "./serializers/goals/badge.js"
import * as amdModule248 from "./serializers/goals/base.js"
import * as amdModule249 from "./serializers/goals/category.js"
import * as amdModule250 from "./serializers/goals/goal.js"
import * as amdModule251 from "./serializers/goals/state.js"
import * as amdModule252 from "./serializers/goals/subcategory.js"
import * as amdModule253 from "./serializers/goals/subject.js"
import * as amdModule254 from "./serializers/media.js"
import * as amdModule255 from "./serializers/milestones/base.js"
import * as amdModule256 from "./serializers/milestones/expectation.js"
import * as amdModule257 from "./serializers/milestones/level.js"
import * as amdModule258 from "./serializers/milestones/milestone-set.js"
import * as amdModule259 from "./serializers/milestones/milestone.js"
import * as amdModule260 from "./serializers/milestones/progression.js"
import * as amdModule261 from "./serializers/person.js"
import * as amdModule262 from "./serializers/posts/attendancenote.js"
import * as amdModule263 from "./serializers/posts/base.js"
import * as amdModule264 from "./serializers/posts/feed-entry.js"
import * as amdModule265 from "./serializers/posts/globalnotice.js"
import * as amdModule266 from "./serializers/posts/page-set.js"
import * as amdModule267 from "./serializers/posts/post-template.js"
import * as amdModule268 from "./serializers/posts/reaction.js"
import * as amdModule269 from "./serializers/posts/tag-category.js"
import * as amdModule270 from "./serializers/posts/tag.js"
import * as amdModule271 from "./serializers/reports/base.js"
import * as amdModule272 from "./serializers/reports/report-feedback.js"
import * as amdModule273 from "./serializers/reports/report-template-section.js"
import * as amdModule274 from "./serializers/reports/report-template.js"
import * as amdModule275 from "./serializers/reports/rubric-criteria.js"
import * as amdModule276 from "./serializers/reports/rubric-element.js"
import * as amdModule277 from "./serializers/reports/rubric-family.js"
import * as amdModule278 from "./serializers/reports/rubric-state.js"
import * as amdModule279 from "./serializers/reports/rubric.js"
import * as amdModule280 from "./serializers/reports/student-report-section.js"
import * as amdModule281 from "./serializers/reports/student-report.js"
import * as amdModule282 from "./serializers/school-options/field.js"
import * as amdModule283 from "./serializers/school-options/group.js"
import * as amdModule284 from "./serializers/school-options/heading.js"
import * as amdModule285 from "./serializers/school.js"
import * as amdModule286 from "./serializers/sif/au/base.js"
import * as amdModule287 from "./serializers/sif/au/connection.js"
import * as amdModule288 from "./serializers/sif/au/zone.js"
import * as amdModule289 from "./serializers/surveys/base.js"
import * as amdModule290 from "./serializers/surveys/response.js"
import * as amdModule291 from "./serializers/surveys/survey.js"
import * as amdModule292 from "./serializers/timetable/base.js"
import * as amdModule293 from "./serializers/timetable/period.js"
import * as amdModule294 from "./serializers/timetable/structure.js"
import * as amdModule295 from "./serializers/user.js"
import * as amdModule296 from "./serializers/wonde/connection.js"
import * as amdModule297 from "./serializers/wonde/school.js"
import * as amdModule298 from "./services/colours.js"
import * as amdModule299 from "./services/dates.js"
import * as amdModule300 from "./services/environment.js"
import * as amdModule301 from "./services/faro.js"
import * as amdModule302 from "./services/fetch.js"
import * as amdModule303 from "./services/field-options.js"
import * as amdModule304 from "./services/google-drive.js"
import * as amdModule305 from "./services/group-years.js"
import * as amdModule306 from "./services/hero-api-auth.js"
import * as amdModule307 from "./services/hero-api-bookings-allocations.js"
import * as amdModule308 from "./services/hero-api-bookings.js"
import * as amdModule309 from "./services/hero-api-comments.js"
import * as amdModule310 from "./services/hero-api-goals.js"
import * as amdModule311 from "./services/hero-api-people.js"
import * as amdModule312 from "./services/hero-api.js"
import * as amdModule313 from "./services/logging.js"
import * as amdModule314 from "./services/media.js"
import * as amdModule315 from "./services/notifications.js"
import * as amdModule316 from "./services/options.js"
import * as amdModule317 from "./services/permissions.js"
import * as amdModule318 from "./services/person-options.js"
import * as amdModule319 from "./services/policy-acceptance.js"
import * as amdModule320 from "./services/print.js"
import * as amdModule321 from "./services/push-notifications.js"
import * as amdModule322 from "./services/roles.js"
import * as amdModule323 from "./services/session.js"
import * as amdModule324 from "./services/tax.js"
import * as amdModule325 from "./services/toaster.js"
import * as amdModule326 from "./services/uppy.js"
import * as amdModule327 from "./transforms/json.js"
import * as amdModule328 from "./utils/auditing.js"
import * as amdModule329 from "./utils/chunk.js"
import * as amdModule330 from "./utils/colour.js"
import * as amdModule331 from "./utils/d3-tip.js"
import * as amdModule332 from "./utils/dynamic-field-types.js"
import * as amdModule333 from "./utils/fields.js"
import * as amdModule334 from "./utils/filtering.js"
import * as amdModule335 from "./utils/grades.js"
import * as amdModule336 from "./utils/long-tasks.js"
import * as amdModule337 from "./utils/map-with-concurrency.js"
import * as amdModule338 from "./utils/oauth2.js"
import * as amdModule339 from "./utils/options.js"
import * as amdModule340 from "./utils/platform.js"
import * as amdModule341 from "./utils/post-templates.js"
import * as amdModule342 from "./utils/progressions.js"
import * as amdModule343 from "./utils/pronouns.js"
import * as amdModule344 from "./utils/reports.js"
import * as amdModule345 from "./utils/school-date.js"
import * as amdModule346 from "./utils/snapshots.js"
import * as amdModule347 from "./utils/stationery.js"
import * as amdModule348 from "./utils/strings.js"
import * as amdModule349 from "./utils/table.js"
import * as amdModule350 from "./utils/tags.js"
import * as amdModule351 from "./utils/tinymce.js"
import * as amdModule352 from "./utils/topic-steps.js"
import * as amdModule353 from "./services/page-title.js"
import * as amdModule354 from "./services/drag-sort.js"
import * as amdModule355 from "./templates/application.hbs"
import * as amdModule356 from "./controllers/application.js"
import * as amdModule357 from "./routes/application.js"
import * as amdModule358 from "./controllers/assessments/assessment.js"
import * as amdModule359 from "./templates/error.hbs"
import * as amdModule360 from "./controllers/error.js"
import * as amdModule361 from "./templates/goal.hbs"
import * as amdModule362 from "./controllers/goal.js"
import * as amdModule363 from "./routes/goal.js"
import * as amdModule364 from "./templates/goals.hbs"
import * as amdModule365 from "./controllers/goals.js"
import * as amdModule366 from "./routes/goals.js"
import * as amdModule367 from "./templates/home.hbs"
import * as amdModule368 from "./controllers/home.js"
import * as amdModule369 from "./routes/home.js"
import * as amdModule370 from "./templates/my-feed.hbs"
import * as amdModule371 from "./controllers/my-feed.js"
import * as amdModule372 from "./routes/my-feed.js"
import * as amdModule373 from "./templates/my-profile.hbs"
import * as amdModule374 from "./controllers/my-profile.js"
import * as amdModule375 from "./routes/my-profile.js"
import * as amdModule376 from "./templates/page.hbs"
import * as amdModule377 from "./controllers/page.js"
import * as amdModule378 from "./routes/page.js"
import * as amdModule379 from "./templates/page/assessment.hbs"
import * as amdModule380 from "./controllers/page/assessment.js"
import * as amdModule381 from "./routes/page/assessment.js"
import * as amdModule382 from "./templates/page/unlinked-posts.hbs"
import * as amdModule383 from "./controllers/page/unlinked-posts.js"
import * as amdModule384 from "./routes/page/unlinked-posts.js"
import * as amdModule385 from "./templates/page/index.hbs"
import * as amdModule386 from "./routes/page/index.js"
import * as amdModule387 from "./templates/post.hbs"
import * as amdModule388 from "./controllers/post.js"
import * as amdModule389 from "./routes/post.js"
import * as amdModule390 from "./templates/student-notices.hbs"
import * as amdModule391 from "./routes/student-notices.js"
import * as amdModule392 from "./templates/student-notices/index.hbs"
import * as amdModule393 from "./controllers/student-notices/index.js"
import * as amdModule394 from "./routes/student-notices/index.js"
import * as amdModule395 from "./templates/student-notices/notice.hbs"
import * as amdModule396 from "./routes/student-notices/notice.js"
import * as amdModule397 from "./templates/student-notices/notice-error.hbs"
import * as amdModule398 from "./templates/index.hbs"
import * as amdModule399 from "./routes/index.js"
import * as amdModule400 from "./templates/logged-out.js"
import * as amdModule401 from "./controllers/logged-out.js"
import * as amdModule402 from "./routes/logged-out.js"
import * as amdModule403 from "./templates/login-failed.js"
import * as amdModule404 from "./controllers/login-failed.js"
import * as amdModule405 from "./routes/login-failed.js"
import * as amdModule406 from "./templates/school-switching.js"
import * as amdModule407 from "./controllers/school-switching.js"
import * as amdModule408 from "./routes/school-switching.js"
import * as amdModule409 from "./templates/callback.js"
import * as amdModule410 from "./routes/callback.js"
import * as amdModule411 from "./routes/login.js"
import * as amdModule412 from "./templates/logout.js"
import * as amdModule413 from "./routes/logout.js"
import * as amdModule414 from "./routes/springboard.js"
import * as amdModule415 from "./routes/startup.js"
import * as amdModule416 from "./templates/not-found.js"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"linced-learners/adapters/application": amdModule0,
"linced-learners/adapters/assessments/assessment": amdModule1,
"linced-learners/adapters/assessments/base": amdModule2,
"linced-learners/adapters/assessments/grade-schedule": amdModule3,
"linced-learners/adapters/assessments/grade": amdModule4,
"linced-learners/adapters/assessments/module": amdModule5,
"linced-learners/adapters/goals/badge": amdModule6,
"linced-learners/adapters/goals/base": amdModule7,
"linced-learners/adapters/goals/category": amdModule8,
"linced-learners/adapters/goals/goal": amdModule9,
"linced-learners/adapters/goals/state": amdModule10,
"linced-learners/adapters/goals/subcategory": amdModule11,
"linced-learners/adapters/goals/subject": amdModule12,
"linced-learners/adapters/media": amdModule13,
"linced-learners/adapters/notifications/base": amdModule14,
"linced-learners/adapters/notifications/notification": amdModule15,
"linced-learners/adapters/notifications/result": amdModule16,
"linced-learners/adapters/people-schema/base": amdModule17,
"linced-learners/adapters/people-schema/field": amdModule18,
"linced-learners/adapters/posts/base": amdModule19,
"linced-learners/adapters/posts/comment": amdModule20,
"linced-learners/adapters/posts/feed-entry": amdModule21,
"linced-learners/adapters/posts/page": amdModule22,
"linced-learners/adapters/posts/post": amdModule23,
"linced-learners/adapters/posts/reaction": amdModule24,
"linced-learners/adapters/posts/studentnotice": amdModule25,
"linced-learners/adapters/posts/tag-category": amdModule26,
"linced-learners/adapters/posts/tag": amdModule27,
"linced-learners/adapters/school-options/base": amdModule28,
"linced-learners/adapters/school-options/field": amdModule29,
"linced-learners/adapters/school-options/group": amdModule30,
"linced-learners/adapters/school-options/heading": amdModule31,
"linced-learners/adapters/surveys/base": amdModule32,
"linced-learners/adapters/surveys/response": amdModule33,
"linced-learners/adapters/surveys/survey": amdModule34,
"linced-learners/adapters/term": amdModule35,
"linced-learners/adapters/timeframe": amdModule36,
"linced-learners/config/environment": amdModule37,
"linced-learners/deprecation-workflow": amdModule38,
"linced-learners/enums/grading-method": amdModule39,
"linced-learners/models/media": amdModule40,
"linced-learners/models/person": amdModule41,
"linced-learners/models/posts/comment": amdModule42,
"linced-learners/models/posts/page": amdModule43,
"linced-learners/models/posts/post": amdModule44,
"linced-learners/models/posts/reaction": amdModule45,
"linced-learners/models/posts/studentnotice": amdModule46,
"linced-learners/router": amdModule47,
"linced-learners/serializers/application": amdModule48,
"linced-learners/serializers/assessments/assessment": amdModule49,
"linced-learners/serializers/assessments/base": amdModule50,
"linced-learners/serializers/assessments/category": amdModule51,
"linced-learners/serializers/assessments/grade-schedule": amdModule52,
"linced-learners/serializers/assessments/grade": amdModule53,
"linced-learners/serializers/assessments/module": amdModule54,
"linced-learners/serializers/people-schema/base": amdModule55,
"linced-learners/serializers/people-schema/field": amdModule56,
"linced-learners/serializers/posts/comment": amdModule57,
"linced-learners/serializers/posts/page": amdModule58,
"linced-learners/serializers/posts/post": amdModule59,
"linced-learners/serializers/posts/studentnotice": amdModule60,
"linced-learners/serializers/term": amdModule61,
"linced-learners/services/application-data": amdModule62,
"linced-learners/services/store": amdModule63,
"linced-learners/services/strings": amdModule64,
"linced-learners/services/terms": amdModule65,
"linced-learners/initializers/viewport-config": amdModule66,
"linced-learners/services/in-viewport": amdModule67,
"linced-learners/services/-ensure-registered": amdModule68,
"linced-learners/instance-initializers/ember-href-to": amdModule69,
"linced-learners/services/constants": amdModule70,
"linced-learners/services/paper-sidenav": amdModule71,
"linced-learners/services/paper-theme": amdModule72,
"linced-learners/services/paper-toaster": amdModule73,
"linced-learners/services/sniffer": amdModule74,
"linced-learners/utils/clamp": amdModule75,
"linced-learners/transforms/array": amdModule76,
"linced-learners/transforms/fragment-array": amdModule77,
"linced-learners/transforms/fragment": amdModule78,
"linced-learners/initializers/ember-data": amdModule79,
"linced-learners/transforms/date": amdModule80,
"linced-learners/transforms/number": amdModule81,
"linced-learners/transforms/string": amdModule82,
"linced-learners/transforms/boolean": amdModule83,
"linced-learners/instance-initializers/ember-router-scroll": amdModule84,
"linced-learners/services/router-scroll": amdModule85,
"linced-learners/data-adapter": amdModule86,
"linced-learners/adapters/base": amdModule87,
"linced-learners/adapters/device": amdModule88,
"linced-learners/adapters/group": amdModule89,
"linced-learners/adapters/person": amdModule90,
"linced-learners/adapters/policy": amdModule91,
"linced-learners/adapters/school": amdModule92,
"linced-learners/adapters/user": amdModule93,
"linced-learners/initializers/fragment-array-iterable": amdModule94,
"linced-learners/initializers/fragment-array-mutable": amdModule95,
"linced-learners/initializers/oauth2": amdModule96,
"linced-learners/initializers/query-params-helper": amdModule97,
"linced-learners/instance-initializers/faro": amdModule98,
"linced-learners/models/address": amdModule99,
"linced-learners/models/assessments/assessment": amdModule100,
"linced-learners/models/assessments/category": amdModule101,
"linced-learners/models/assessments/grade-schedule": amdModule102,
"linced-learners/models/assessments/grade": amdModule103,
"linced-learners/models/assessments/gradeschedule-numeric": amdModule104,
"linced-learners/models/assessments/gradeschedule-range": amdModule105,
"linced-learners/models/assessments/gradeschedule-select": amdModule106,
"linced-learners/models/assessments/gradeschedule-selectvalue": amdModule107,
"linced-learners/models/assessments/module": amdModule108,
"linced-learners/models/attendance/nz-moe-day": amdModule109,
"linced-learners/models/auth/qr-code": amdModule110,
"linced-learners/models/autogroup-params": amdModule111,
"linced-learners/models/bookings/allocation": amdModule112,
"linced-learners/models/bookings/booking": amdModule113,
"linced-learners/models/bookings/date": amdModule114,
"linced-learners/models/bookings/event": amdModule115,
"linced-learners/models/bookings/reservation": amdModule116,
"linced-learners/models/bookings/session": amdModule117,
"linced-learners/models/bookings/slot": amdModule118,
"linced-learners/models/bookings/teacher-group-mapping": amdModule119,
"linced-learners/models/cron/process-monitor-error": amdModule120,
"linced-learners/models/cron/process-monitor": amdModule121,
"linced-learners/models/cron/progress": amdModule122,
"linced-learners/models/device": amdModule123,
"linced-learners/models/dynamic-field/value-list-item": amdModule124,
"linced-learners/models/dynamic-field/value": amdModule125,
"linced-learners/models/dynamic-field/values": amdModule126,
"linced-learners/models/enrolments/field": amdModule127,
"linced-learners/models/enrolments/medical-condition": amdModule128,
"linced-learners/models/enrolments/schema": amdModule129,
"linced-learners/models/enrolments/section": amdModule130,
"linced-learners/models/events/cost-mapping-option": amdModule131,
"linced-learners/models/events/cost-mapping": amdModule132,
"linced-learners/models/events/event-count": amdModule133,
"linced-learners/models/events/event": amdModule134,
"linced-learners/models/events/mitigation": amdModule135,
"linced-learners/models/events/option-count": amdModule136,
"linced-learners/models/events/option-limit": amdModule137,
"linced-learners/models/events/permission-reply": amdModule138,
"linced-learners/models/events/permission": amdModule139,
"linced-learners/models/events/risk": amdModule140,
"linced-learners/models/events/template": amdModule141,
"linced-learners/models/events/value-limit": amdModule142,
"linced-learners/models/finance/account": amdModule143,
"linced-learners/models/finance/line-item": amdModule144,
"linced-learners/models/goals/badge-assertion": amdModule145,
"linced-learners/models/goals/badge-badge": amdModule146,
"linced-learners/models/goals/badge-criteria": amdModule147,
"linced-learners/models/goals/badge-profile": amdModule148,
"linced-learners/models/goals/badge-recipient": amdModule149,
"linced-learners/models/goals/badge-verification": amdModule150,
"linced-learners/models/goals/badge": amdModule151,
"linced-learners/models/goals/category": amdModule152,
"linced-learners/models/goals/goal": amdModule153,
"linced-learners/models/goals/state": amdModule154,
"linced-learners/models/goals/subcategory": amdModule155,
"linced-learners/models/goals/subject": amdModule156,
"linced-learners/models/group": amdModule157,
"linced-learners/models/groups/member": amdModule158,
"linced-learners/models/media/image": amdModule159,
"linced-learners/models/media/rendition": amdModule160,
"linced-learners/models/media/video": amdModule161,
"linced-learners/models/milestones/expectation": amdModule162,
"linced-learners/models/milestones/level": amdModule163,
"linced-learners/models/milestones/milestone-set": amdModule164,
"linced-learners/models/milestones/milestone": amdModule165,
"linced-learners/models/milestones/progression": amdModule166,
"linced-learners/models/notifications/notification": amdModule167,
"linced-learners/models/people-schema/field-option": amdModule168,
"linced-learners/models/people-schema/field": amdModule169,
"linced-learners/models/people-schema/group": amdModule170,
"linced-learners/models/people/caregiver": amdModule171,
"linced-learners/models/people/learner": amdModule172,
"linced-learners/models/people/medical": amdModule173,
"linced-learners/models/people/options": amdModule174,
"linced-learners/models/people/policy-acceptance": amdModule175,
"linced-learners/models/people/post-count-assessment": amdModule176,
"linced-learners/models/people/post-count-base": amdModule177,
"linced-learners/models/people/post-count-goal": amdModule178,
"linced-learners/models/people/post-count-page": amdModule179,
"linced-learners/models/people/post-counts": amdModule180,
"linced-learners/models/people/staff": amdModule181,
"linced-learners/models/policy": amdModule182,
"linced-learners/models/posts/attendancenote": amdModule183,
"linced-learners/models/posts/feed-entry": amdModule184,
"linced-learners/models/posts/globalnotice": amdModule185,
"linced-learners/models/posts/member": amdModule186,
"linced-learners/models/posts/page-set": amdModule187,
"linced-learners/models/posts/post-template": amdModule188,
"linced-learners/models/posts/tag-category": amdModule189,
"linced-learners/models/posts/tag": amdModule190,
"linced-learners/models/reports/report-feedback": amdModule191,
"linced-learners/models/reports/report-judgement-wording": amdModule192,
"linced-learners/models/reports/report-template-period": amdModule193,
"linced-learners/models/reports/report-template-section": amdModule194,
"linced-learners/models/reports/report-template": amdModule195,
"linced-learners/models/reports/rubric-column": amdModule196,
"linced-learners/models/reports/rubric-criteria": amdModule197,
"linced-learners/models/reports/rubric-element": amdModule198,
"linced-learners/models/reports/rubric-family": amdModule199,
"linced-learners/models/reports/rubric-state": amdModule200,
"linced-learners/models/reports/rubric": amdModule201,
"linced-learners/models/reports/student-report-section-element": amdModule202,
"linced-learners/models/reports/student-report-section": amdModule203,
"linced-learners/models/reports/student-report": amdModule204,
"linced-learners/models/school-options/field": amdModule205,
"linced-learners/models/school-options/group": amdModule206,
"linced-learners/models/school-options/heading": amdModule207,
"linced-learners/models/school": amdModule208,
"linced-learners/models/schools/location": amdModule209,
"linced-learners/models/sif/au/connection": amdModule210,
"linced-learners/models/sif/au/zone": amdModule211,
"linced-learners/models/snapshots/pdf-include": amdModule212,
"linced-learners/models/snapshots/pdf": amdModule213,
"linced-learners/models/snapshots/snapshot-set": amdModule214,
"linced-learners/models/snapshots/snapshot": amdModule215,
"linced-learners/models/surveys/response": amdModule216,
"linced-learners/models/surveys/survey": amdModule217,
"linced-learners/models/term": amdModule218,
"linced-learners/models/timeframe": amdModule219,
"linced-learners/models/timetable/day": amdModule220,
"linced-learners/models/timetable/period": amdModule221,
"linced-learners/models/timetable/structure": amdModule222,
"linced-learners/models/user": amdModule223,
"linced-learners/models/wonde/address": amdModule224,
"linced-learners/models/wonde/connection": amdModule225,
"linced-learners/models/wonde/school": amdModule226,
"linced-learners/serializers/address": amdModule227,
"linced-learners/serializers/auth/base": amdModule228,
"linced-learners/serializers/auth/qr-code": amdModule229,
"linced-learners/serializers/bookings/allocation": amdModule230,
"linced-learners/serializers/bookings/base": amdModule231,
"linced-learners/serializers/bookings/booking": amdModule232,
"linced-learners/serializers/bookings/event": amdModule233,
"linced-learners/serializers/bookings/slot": amdModule234,
"linced-learners/serializers/cron/process-monitor": amdModule235,
"linced-learners/serializers/dynamic-field/value": amdModule236,
"linced-learners/serializers/events/base": amdModule237,
"linced-learners/serializers/events/cost-mapping-option": amdModule238,
"linced-learners/serializers/events/cost-mapping": amdModule239,
"linced-learners/serializers/events/event-count": amdModule240,
"linced-learners/serializers/events/event": amdModule241,
"linced-learners/serializers/events/mitigation": amdModule242,
"linced-learners/serializers/events/permission-reply": amdModule243,
"linced-learners/serializers/events/permission": amdModule244,
"linced-learners/serializers/events/risk": amdModule245,
"linced-learners/serializers/events/template": amdModule246,
"linced-learners/serializers/goals/badge": amdModule247,
"linced-learners/serializers/goals/base": amdModule248,
"linced-learners/serializers/goals/category": amdModule249,
"linced-learners/serializers/goals/goal": amdModule250,
"linced-learners/serializers/goals/state": amdModule251,
"linced-learners/serializers/goals/subcategory": amdModule252,
"linced-learners/serializers/goals/subject": amdModule253,
"linced-learners/serializers/media": amdModule254,
"linced-learners/serializers/milestones/base": amdModule255,
"linced-learners/serializers/milestones/expectation": amdModule256,
"linced-learners/serializers/milestones/level": amdModule257,
"linced-learners/serializers/milestones/milestone-set": amdModule258,
"linced-learners/serializers/milestones/milestone": amdModule259,
"linced-learners/serializers/milestones/progression": amdModule260,
"linced-learners/serializers/person": amdModule261,
"linced-learners/serializers/posts/attendancenote": amdModule262,
"linced-learners/serializers/posts/base": amdModule263,
"linced-learners/serializers/posts/feed-entry": amdModule264,
"linced-learners/serializers/posts/globalnotice": amdModule265,
"linced-learners/serializers/posts/page-set": amdModule266,
"linced-learners/serializers/posts/post-template": amdModule267,
"linced-learners/serializers/posts/reaction": amdModule268,
"linced-learners/serializers/posts/tag-category": amdModule269,
"linced-learners/serializers/posts/tag": amdModule270,
"linced-learners/serializers/reports/base": amdModule271,
"linced-learners/serializers/reports/report-feedback": amdModule272,
"linced-learners/serializers/reports/report-template-section": amdModule273,
"linced-learners/serializers/reports/report-template": amdModule274,
"linced-learners/serializers/reports/rubric-criteria": amdModule275,
"linced-learners/serializers/reports/rubric-element": amdModule276,
"linced-learners/serializers/reports/rubric-family": amdModule277,
"linced-learners/serializers/reports/rubric-state": amdModule278,
"linced-learners/serializers/reports/rubric": amdModule279,
"linced-learners/serializers/reports/student-report-section": amdModule280,
"linced-learners/serializers/reports/student-report": amdModule281,
"linced-learners/serializers/school-options/field": amdModule282,
"linced-learners/serializers/school-options/group": amdModule283,
"linced-learners/serializers/school-options/heading": amdModule284,
"linced-learners/serializers/school": amdModule285,
"linced-learners/serializers/sif/au/base": amdModule286,
"linced-learners/serializers/sif/au/connection": amdModule287,
"linced-learners/serializers/sif/au/zone": amdModule288,
"linced-learners/serializers/surveys/base": amdModule289,
"linced-learners/serializers/surveys/response": amdModule290,
"linced-learners/serializers/surveys/survey": amdModule291,
"linced-learners/serializers/timetable/base": amdModule292,
"linced-learners/serializers/timetable/period": amdModule293,
"linced-learners/serializers/timetable/structure": amdModule294,
"linced-learners/serializers/user": amdModule295,
"linced-learners/serializers/wonde/connection": amdModule296,
"linced-learners/serializers/wonde/school": amdModule297,
"linced-learners/services/colours": amdModule298,
"linced-learners/services/dates": amdModule299,
"linced-learners/services/environment": amdModule300,
"linced-learners/services/faro": amdModule301,
"linced-learners/services/fetch": amdModule302,
"linced-learners/services/field-options": amdModule303,
"linced-learners/services/google-drive": amdModule304,
"linced-learners/services/group-years": amdModule305,
"linced-learners/services/hero-api-auth": amdModule306,
"linced-learners/services/hero-api-bookings-allocations": amdModule307,
"linced-learners/services/hero-api-bookings": amdModule308,
"linced-learners/services/hero-api-comments": amdModule309,
"linced-learners/services/hero-api-goals": amdModule310,
"linced-learners/services/hero-api-people": amdModule311,
"linced-learners/services/hero-api": amdModule312,
"linced-learners/services/logging": amdModule313,
"linced-learners/services/media": amdModule314,
"linced-learners/services/notifications": amdModule315,
"linced-learners/services/options": amdModule316,
"linced-learners/services/permissions": amdModule317,
"linced-learners/services/person-options": amdModule318,
"linced-learners/services/policy-acceptance": amdModule319,
"linced-learners/services/print": amdModule320,
"linced-learners/services/push-notifications": amdModule321,
"linced-learners/services/roles": amdModule322,
"linced-learners/services/session": amdModule323,
"linced-learners/services/tax": amdModule324,
"linced-learners/services/toaster": amdModule325,
"linced-learners/services/uppy": amdModule326,
"linced-learners/transforms/json": amdModule327,
"linced-learners/utils/auditing": amdModule328,
"linced-learners/utils/chunk": amdModule329,
"linced-learners/utils/colour": amdModule330,
"linced-learners/utils/d3-tip": amdModule331,
"linced-learners/utils/dynamic-field-types": amdModule332,
"linced-learners/utils/fields": amdModule333,
"linced-learners/utils/filtering": amdModule334,
"linced-learners/utils/grades": amdModule335,
"linced-learners/utils/long-tasks": amdModule336,
"linced-learners/utils/map-with-concurrency": amdModule337,
"linced-learners/utils/oauth2": amdModule338,
"linced-learners/utils/options": amdModule339,
"linced-learners/utils/platform": amdModule340,
"linced-learners/utils/post-templates": amdModule341,
"linced-learners/utils/progressions": amdModule342,
"linced-learners/utils/pronouns": amdModule343,
"linced-learners/utils/reports": amdModule344,
"linced-learners/utils/school-date": amdModule345,
"linced-learners/utils/snapshots": amdModule346,
"linced-learners/utils/stationery": amdModule347,
"linced-learners/utils/strings": amdModule348,
"linced-learners/utils/table": amdModule349,
"linced-learners/utils/tags": amdModule350,
"linced-learners/utils/tinymce": amdModule351,
"linced-learners/utils/topic-steps": amdModule352,
"linced-learners/services/page-title": amdModule353,
"linced-learners/services/drag-sort": amdModule354,
"linced-learners/templates/application": amdModule355,
"linced-learners/controllers/application": amdModule356,
"linced-learners/routes/application": amdModule357,
"linced-learners/controllers/assessments/assessment": amdModule358,
"linced-learners/templates/error": amdModule359,
"linced-learners/controllers/error": amdModule360,
"linced-learners/templates/goal": amdModule361,
"linced-learners/controllers/goal": amdModule362,
"linced-learners/routes/goal": amdModule363,
"linced-learners/templates/goals": amdModule364,
"linced-learners/controllers/goals": amdModule365,
"linced-learners/routes/goals": amdModule366,
"linced-learners/templates/home": amdModule367,
"linced-learners/controllers/home": amdModule368,
"linced-learners/routes/home": amdModule369,
"linced-learners/templates/my-feed": amdModule370,
"linced-learners/controllers/my-feed": amdModule371,
"linced-learners/routes/my-feed": amdModule372,
"linced-learners/templates/my-profile": amdModule373,
"linced-learners/controllers/my-profile": amdModule374,
"linced-learners/routes/my-profile": amdModule375,
"linced-learners/templates/page": amdModule376,
"linced-learners/controllers/page": amdModule377,
"linced-learners/routes/page": amdModule378,
"linced-learners/templates/page/assessment": amdModule379,
"linced-learners/controllers/page/assessment": amdModule380,
"linced-learners/routes/page/assessment": amdModule381,
"linced-learners/templates/page/unlinked-posts": amdModule382,
"linced-learners/controllers/page/unlinked-posts": amdModule383,
"linced-learners/routes/page/unlinked-posts": amdModule384,
"linced-learners/templates/page/index": amdModule385,
"linced-learners/routes/page/index": amdModule386,
"linced-learners/templates/post": amdModule387,
"linced-learners/controllers/post": amdModule388,
"linced-learners/routes/post": amdModule389,
"linced-learners/templates/student-notices": amdModule390,
"linced-learners/routes/student-notices": amdModule391,
"linced-learners/templates/student-notices/index": amdModule392,
"linced-learners/controllers/student-notices/index": amdModule393,
"linced-learners/routes/student-notices/index": amdModule394,
"linced-learners/templates/student-notices/notice": amdModule395,
"linced-learners/routes/student-notices/notice": amdModule396,
"linced-learners/templates/student-notices/notice-error": amdModule397,
"linced-learners/templates/index": amdModule398,
"linced-learners/routes/index": amdModule399,
"linced-learners/templates/logged-out": amdModule400,
"linced-learners/controllers/logged-out": amdModule401,
"linced-learners/routes/logged-out": amdModule402,
"linced-learners/templates/login-failed": amdModule403,
"linced-learners/controllers/login-failed": amdModule404,
"linced-learners/routes/login-failed": amdModule405,
"linced-learners/templates/school-switching": amdModule406,
"linced-learners/controllers/school-switching": amdModule407,
"linced-learners/routes/school-switching": amdModule408,
"linced-learners/templates/callback": amdModule409,
"linced-learners/routes/callback": amdModule410,
"linced-learners/routes/login": amdModule411,
"linced-learners/templates/logout": amdModule412,
"linced-learners/routes/logout": amdModule413,
"linced-learners/routes/springboard": amdModule414,
"linced-learners/routes/startup": amdModule415,
"linced-learners/templates/not-found": amdModule416,
  },
  exportFastbootModules
);
